import React from 'react';
import cx from 'classnames';

import {useDelayedVisibility} from './useDelayedVisibility';

export interface WithTransitionProps {
    isVisible: boolean;
    className?: string;
}

export function withTransition<P extends object>(
    Component: React.ComponentType<P>,
    timeout: number,
    stateAfterTransition: 'unmount' | 'hide' = 'unmount',
) {
    return function WrappedWithTransition(props: P & WithTransitionProps) {
        const {isVisible, className, ...restProps} =
            props as WithTransitionProps;

        const areChildrenVisible = useDelayedVisibility(isVisible, timeout);

        if (!areChildrenVisible && stateAfterTransition === 'unmount') {
            return null;
        }

        return (
            <Component
                {...(restProps as P)}
                className={cx(className, !areChildrenVisible && 'd-none')}
            />
        );
    };
}
